import EnvWindow from "../../utils/env";
import { downloadFile } from "../../utils/servicesHelper";

export const downloadSioePkzExportReport = (exportResultStateId: string, fileName: string) => {
  downloadFile(`${EnvWindow.REACT_APP_RESULTS_API_URL}/ExamSheet/ExportResultState/${exportResultStateId}`, fileName);
};

export async function downloadExamResultsReport(reportId: string, fileName: string) {
  await downloadFile(`${EnvWindow.REACT_APP_RESULTS_API_URL}/Results/Report/${reportId}`, fileName);
}